var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spl-report-list-header"},[_c('form-button',{on:{"onClick":_vm.handleCreateReport}},[_vm._v(" Create Report ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }